import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, TitleCasePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TransactionsLayoutRoutingModule } from './transactions-layout-routing.module';
import { TransactionsLayoutComponent } from './transactions-layout.component';
import { TransactionsListComponent } from './components/transactions-list/transactions-list.component';
import { TransactionDetailsComponent } from './components/transaction-details/transaction-details.component';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import {
  RouterExtService,
  SettlementsService,
  TransactionFormatterService,
  TransactionsService,
} from './services';
import { TransactionsListPageComponent } from './transactions-list-page/transactions-list-page.component';
import { MatStepperModule } from '@angular/material/stepper';
import { TransactionsFiltersModule } from './components/filters/filters.module';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  CorePipesModule,
  OdinCoreModule,
} from '@odin/odin-core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TransactionsEffects } from '../+state/transactions/transactions.effects';
import * as fromTransactions from '../+state/transactions/transactions.reducer';
import * as fromSettlements from '../+state/settlements/settlements.reducer';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TimelineComponent } from './components/timeline/timeline.component';
import { BackToTopComponent } from './components/back-to-top/back-to-top.component';
import { ChipStatusComponent } from './components/chip-status/chip-status.component';
import { MatDialogModule } from '@angular/material/dialog';
import { CsvReportsDialogComponent } from './components/csv-reports-dialog/csv-reports-dialog.component';
import { NewExperienceBannerComponent } from './new-experience-banner/new-experience-banner.component';
import { SettlementListPageComponent } from './settlement-list-page/settlement-list-page.component';
import { SettlementsListComponent } from './components/settlements-list/settlements-list.component';
import { SettlementsEffects } from '../+state/settlements/settlements.effects';
import { SettlementDailyPageComponent } from './settlement-daily-page/settlement-daily-page.component';
import { SettlementDailyListComponent } from './components/settlement-daily-list/settlement-daily-list.component';
import { MatCardModule } from '@angular/material/card';
import { SettlementDailyReportDownloadComponent } from './components/settlement-daily-report-download/settlement-daily-report-download.component';
import { SettlementReportsService } from './services/settlement-reports.service';
import { SettlementsToggleComponent } from './components/settlements-toggle/settlements-toggle.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SettlementsMonthlyListComponent } from './components/settlements-monthly-list/settlements-monthly-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { TransactionsFacade } from '../+state/transactions/transactions.facade';
import { PrintReceiptComponent } from '../print-receipt/print-receipt.component';
import { PrintInvoiceComponent } from '../print-invoice/print-invoice.component';
import { InvoiceOptionsModalComponent } from '../transaction-detail-page/components/invoice-options-modal/invoice-options-modal.component';
import { PeblTrackingPageComponent } from './pebl-tracking-page/pebl-tracking-page.component';
import { PeblScheduledListComponent } from './pebl-scheduled-list/pebl-scheduled-list.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { TransactionDetailPageComponent } from '../transaction-detail-page/transaction-detail-page.component';
import { LegacyTransactionDetailPageComponent } from '../transaction-detail-page-legacy/transaction-detail-page-legacy.component';
import { OrderTrackingCardComponent } from '../transaction-detail-page/components/order-tracking-card/order-tracking-card.component';
import { TxEventTimelineComponent } from '../transaction-detail-page/components/tx-event-timeline/tx-event-timeline.component';
import { BasketCardComponent } from '../transaction-detail-page/components/basket-card/basket-card.component';
import { MerchantDataCardComponent } from '../transaction-detail-page/components/merchant-data-card/merchant-data-card.component';
import { DevModeChooserComponent } from "libs/odin-core/src/lib/components/dev-mode-chooser/dev-mode-chooser.component";

@NgModule({
  declarations: [
    TransactionsLayoutComponent,
    TransactionsListComponent,
    TransactionDetailsComponent,
    TransactionsListPageComponent,
    TransactionDetailPageComponent,
    LegacyTransactionDetailPageComponent,
    OrderTrackingCardComponent,
    TxEventTimelineComponent,
    BasketCardComponent,
    MerchantDataCardComponent,
    PeblTrackingPageComponent,
    PeblScheduledListComponent,
    SettlementListPageComponent,
    TimelineComponent,
    BackToTopComponent,
    ChipStatusComponent,
    CsvReportsDialogComponent,
    NewExperienceBannerComponent,
    SettlementListPageComponent,
    SettlementsListComponent,
    SettlementDailyPageComponent,
    SettlementDailyListComponent,
    SettlementDailyReportDownloadComponent,
    SettlementsToggleComponent,
    SettlementsMonthlyListComponent,
    PrintReceiptComponent,
    PrintInvoiceComponent,
    InvoiceOptionsModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ScrollingModule,
    TransactionsLayoutRoutingModule,
    MatListModule,
    MatStepperModule,
    MatSidenavModule,
    MatCardModule,
    InfiniteScrollModule,
    TransactionsFiltersModule,
    OdinCoreModule,
    MatChipsModule,
    MatDialogModule,
    MatButtonToggleModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatMenuModule,
    StoreModule.forFeature(fromTransactions.TRANSACTIONS_FEATURE_KEY, fromTransactions.reducer),
    StoreModule.forFeature(fromSettlements.SETTLEMENTS_FEATURE_KEY, fromSettlements.reducer),
    EffectsModule.forFeature([TransactionsEffects, SettlementsEffects]),
    CorePipesModule,
    DevModeChooserComponent
],
  exports: [
    PeblTrackingPageComponent,
    TransactionsLayoutComponent,
    TransactionsFiltersModule,
    ChipStatusComponent,
    SettlementDailyReportDownloadComponent,
    PrintReceiptComponent,
    PrintInvoiceComponent,
  ],
  providers: [
    TransactionsService,
    SettlementsService,
    RouterExtService,
    CurrencyPipe,
    TitleCasePipe,
    SettlementReportsService,
    TransactionFormatterService,
    TransactionsFacade,
  ],
})
export class TransactionsLayoutModule {}
